import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HeadlineCards from "./components/HeadlineCards";
import Food1 from "./components/Food1";
import Catagories from "./components/Catagories";

function App() {
  return (
    <>
      <Navbar/>
      <Hero/>
      <HeadlineCards/>
      <Food1/>
      <Catagories/>
    </>
  );
}

export default App;
